export const deleteAccountRoutes = {
  DELETE_ACCOUNT: "/user", // DELETE (новый API)
};
